import { groq } from 'next-sanity';
import { z } from 'zod';

import { announcement, SanityAnnouncement } from './announcement';
import { footer, SanityFooter } from './footer';
import { header, SanityHeader } from './header';
import { image, SanityImage } from './image';

export const SanitySite = z.object({
  title: z.string(),
  description: z.string(),
  openGraphTitle: z.string(),
  openGraphDescription: z.string(),
  openGraphImage: SanityImage,
  announcement: SanityAnnouncement.nullable(),
  header: SanityHeader,
  footer: SanityFooter,
});
export type SanitySite = z.infer<typeof SanitySite>;

export const site = groq`*[_type == 'site'][0] {
  title,
  description,
  openGraphTitle,
  openGraphDescription,
  openGraphImage ${image},
  announcement-> ${announcement},
  header-> ${header},
  footer-> ${footer},
}`;
